const dashboardConfig = {
  wavefleetUrl: config(
    "REACT_APP_WAVEFLEET_URL",
    "https://api.sofarocean.com",
    "https://api-staging.sofarocean-test.com"
  ),
  mapboxToken: config(
    "REACT_APP_MAPBOX_TOKEN",
    "pk.eyJ1Ijoiam9uc2VuIiwiYSI6IkR6UU9oMDQifQ.dymRIgqv-UV6oz0-HCFx1w"
  ),
  mapboxStyleUrl: config(
    "REACT_APP_MAPBOX_STYLE_URL",
    "mapbox://styles/jonsen/ck10w9t0p056l1do8z0iq14zp"
  ),
  googleAnalyticsTrackingNumber: config(
    "REACT_APP_GA_TRACKING_NO",
    "UA-136244537-5",
    "UA-136244537-6"
  )
};

/** Helper function that lets us pull a config value out of an environment
 *  variable (if present), with fallbacks to a default value in prod
 *  and (optionally) staging.
 */
function config<T>(
  environmentVariable: string,
  defaultValue: T,
  defaultValueStaging?: T
) {
  if (process.env.hasOwnProperty(environmentVariable)) {
    return process.env[environmentVariable];
  } else {
    return process.env.DEPLOY_STAGE === "staging" &&
      defaultValueStaging !== undefined
      ? defaultValueStaging!
      : defaultValue;
  }
}

export default dashboardConfig;
